import classNames from "classnames";
import CloseCampaignModal from "pages/campaigns/CloseCampaignModal";
import Box from "pages/_components/Box";
import { bool, func, number, string } from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { openLink } from "util/browser";
import * as configUtils from "util/config";
import { isMobileNative } from "util/device";

class CampaignItem extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        idCampaign: number.isRequired,
        name: string.isRequired,
        clickable: bool.isRequired,
        url: string.isRequired,
        image: string.isRequired,
        isDesktop: bool.isRequired,
        className: string,
    };

    static defaultProps = {
        className: null,
    };

    state = {
        displayModal: false,
        selectedCampaign: null,
    };

    renderImage = (image, url = null) => (
        <>
            {image === undefined ? (
                <div />
            ) : (
                <Box className="campaign-animate-in">
                    <img
                        className="display-block"
                        src={`data:image/png;base64, ${image}`}
                        alt="Campaign"
                        onClick={url ? () => this.handleClick(url) : null}
                    />
                </Box>
            )}
        </>
    );

    handleClick = (url) => {
        if (isMobileNative) {
            openLink(url).then();
        }
    };

    showModal = () => {
        const { idCampaign } = this.props;
        this.setState({ displayModal: true, selectedCampaign: idCampaign });
    };

    hideModal = () => {
        this.setState({ displayModal: false, selectedCampaign: null });
    };

    render() {
        const { idCampaign, url, image, dispatch, isDesktop, className } = this.props;
        const baseUrl = configUtils.get("client.baseURL");
        const { selectedCampaign, displayModal } = this.state;

        const linkURL = url && url.includes(baseUrl) ? url.replace(baseUrl, "") : url;
        return (
            <Box
                className={classNames("campaignWrapper", className)}
                {...(!isDesktop && { borderRadius: "xl", overflow: "hidden" })}>
                <CloseCampaignModal
                    dispatch={dispatch}
                    idCampaign={selectedCampaign}
                    isDisplayed={displayModal}
                    closeModal={this.hideModal}
                />
                <Box key={idCampaign}>
                    {linkURL ? (
                        // TODO (LABEL a11y)
                        <Link
                            to={{ pathname: linkURL }}
                            aria-label={`ir a ${linkURL}`}
                            replace
                            target="_blank"
                            rel="noreferrer noopener">
                            {this.renderImage(image, linkURL)}
                        </Link>
                    ) : (
                        this.renderImage(image)
                    )}
                </Box>
            </Box>
        );
    }
}

export default CampaignItem;
